import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";
import userInfoService from "@/services/userInfo";

export const goToBookingConfirmation = async (cycle_name, type) => {
  // クレカ情報チェック
  if (await userInfoService.checkCreditCard()) {
    // 予約からの場合はアプリ上でもWebView内で遷移可能
    if (type == "booking" || store.getters["common/device"] == "BROWSER") {
      router.push({
        name: "DbsBookingConfirmation",
        query: {
          type: type,
          cyc_name: cycle_name,
        },
      });
    } else {
      nativeHandlerService.ncDbsOpenWebview(
        `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/booking-confirmation?type=${type}&cyc_name=${cycle_name}`
      );
    }
  } else {
    nativeHandlerService.returnNativeAppToCreditCardPage();
  }
};
